// extracted by mini-css-extract-plugin
module.exports = {"widget":"Widget_widget__1SL9f","title":"Widget_title__2RIYm"};